import getOption from "./getOption.js";
export default (...params) => getOption(false, ...params);
